import {
    People as PeopleIcon,
    AccountBalanceWallet as AccountBalanceWalletIcon,
    Category as CategoryIcon,
    Description as DescriptionIcon,
    TextFields as TextFieldsIcon,
    ViewAgenda as ViewAgendaIcon,
    Dashboard as DashboardIcon,
    TravelExplore as TravelExploreIcon,
    Business as BusinessIcon,
    Receipt as ReceiptIcon,
    Add as AddIcon,
    SmartToy as SmartToyIcon,
    Inventory2 as Inventory2Icon,
} from '@mui/icons-material';
import { PERMS } from './pmPermissions';

export function getPmNavItems(orgId, t) {
    return [
        {
            icon: DashboardIcon,
            label: 'Overview',
            to: `/app/${orgId}/overview`,
            permission: PERMS.ORG_ANALYTICS_VIEW,
        },
        {
            icon: BusinessIcon,
            label: t('app.projects.title'),
            to: `/app/${orgId}/projects`,
            permission: PERMS.PROJECTS_VIEW,
        },
        {
            icon: ReceiptIcon,
            label: t('app.transactions.title'),
            to: `/app/${orgId}/transactions`,
            permission: PERMS.TRANSACTIONS_VIEW,
        },
        {
            icon: DescriptionIcon,
            label: t('app.invoices.title'),
            to: `/app/${orgId}/invoices`,
            permission: PERMS.INVOICES_VIEW,
        },
        {
            icon: TravelExploreIcon,
            label: 'Explore',
            to: `/app/${orgId}/explore`,
            permission: PERMS.ORG_ANALYTICS_VIEW,
        },
    ];
}

export function getPmQuickActionItems(orgId, t) {
    return [
        {
            icon: SmartToyIcon,
            label: t('app.chat.askAssistant'),
            permission: null,
        },
        {
            icon: AddIcon,
            label: t('app.transactions.addTransaction'),
            assistantIntent: 'add_transaction',
            permission: PERMS.TRANSACTIONS_CREATE,
        },
    ];
}

export function getPmDataMenuItems(orgId, t) {
    return [
        {
            text: t('app.fundingSources.title'),
            icon: AccountBalanceWalletIcon,
            path: `/app/${orgId}/accounts`,
            permission: PERMS.ORGANIZATIONS_VIEW,
        },
        {
            text: t('app.suppliers.title'),
            icon: PeopleIcon,
            path: `/app/${orgId}/suppliers`,
            permission: PERMS.SUPPLIERS_VIEW,
        },
        {
            text: t('app.products.title'),
            icon: Inventory2Icon,
            path: `/app/${orgId}/products`,
            permission: PERMS.INVOICES_VIEW,
        },
        {
            text: t('app.metadata.activities.title'),
            icon: CategoryIcon,
            path: `/app/${orgId}/activities`,
            permission: PERMS.PROJECTS_VIEW,
        },
        {
            text: t('app.metadata.projectTemplates.title'),
            icon: DescriptionIcon,
            path: `/app/${orgId}/project-templates`,
            permission: PERMS.ORGANIZATIONS_VIEW,
        },
        {
            text: t('app.metadata.dataFields.title'),
            icon: TextFieldsIcon,
            path: `/app/${orgId}/data-fields`,
            anyOf: [PERMS.ORGANIZATIONS_VIEW, PERMS.PROJ_DATAFIELDS_VIEW],
        },
        {
            text: t('app.metadata.sections.title'),
            icon: ViewAgendaIcon,
            path: `/app/${orgId}/sections`,
            anyOf: [PERMS.ORGANIZATIONS_VIEW, PERMS.PROJ_DATAFIELDS_VIEW],
        },
    ];
}
